import React from "react";
import { editIcon } from "../../utils/config";
import type { EditButtonModel } from "../../type/buttons";
import "./editButton.scss";


const EditButton: React.FC<EditButtonModel> = ({
  onClick,
  title = "Edit",
  className = "",
  disabled = false,
  ariaLabel,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(e);
  };

  return (
    <span className="edit-button-wrapper">
        <button
        type="button"
        className={`edit-button ${className}`.trim()}
        onClick={handleClick}
        title={title}
        aria-label={ariaLabel || title}
        disabled={disabled}
        >
        {editIcon}
        </button>
    </span>
  );
};

export default EditButton;